module.exports = __webpack_public_path__ + "static/media/box.1c0c6eea.png";